import { z } from 'zod'

export const WORK_TASK_TRACKER_PROJECT_MEMBER_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerProjectMemberResponseSchema = z.unknown()
export type WorkTaskTrackerProjectMemberResponse = z.infer<typeof workTaskTrackerProjectMemberResponseSchema>
